import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TextHidingModule} from '../../directives/text-hiding';
import {DropdownMenuModule} from '../dropdown-menu';
import {OverlayModule} from '../overlay';
import {TooltipModule} from '../tooltip';
import {L10nModule} from '../translate';
import {SelectInputObjectIdComponent} from './select-input-object-id.component';
import {SelectInputObjectComponent} from './select-input-object.component';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        OverlayModule,
        DropdownMenuModule,
        TextHidingModule,
        TooltipModule
    ],
    declarations: [
        SelectInputObjectComponent,
        SelectInputObjectIdComponent
    ],
    exports: [
        SelectInputObjectComponent,
        SelectInputObjectIdComponent
    ]
})
export class SelectInputObjectModule {}
